import { createUseStyles } from 'react-jss';
import { theme } from '@align-cpf/uikit-styles';

const { spacing } = theme;

export default createUseStyles(
  {
    root: {},

    tabLabels: {
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'wrap',
      justifyContent: 'flex-start',
      alignItems: 'flex-start',
      width: '100%',
    },
    tabPanels: {
      position: 'relative',
      margin: [spacing.sp03, 0, 0],
    },
  },
  {
    name: 'Tabs',
  },
);
